import axios from "axios";
import qs from "qs";
import * as actionType from "../../../constant/actionType";

const normaliseSelection = (input) => {
  if (!Array.isArray(input)) {
    return [];
  }

  return input
    .map((item) => {
      if (item == null) {
        return null;
      }

      if (typeof item === "object") {
        return (
          item?.provider_org_id ??
          item?.organisation_id ??
          item?.provider_type_id ??
          item?.value ??
          item?.id ??
          null
        );
      }

      return item;
    })
    .filter((value) => value !== null && value !== undefined);
};

export const GenerateLicensingGracePeriodFollowUpsReport = (params = {}) =>
  async () => {
    try {
      const storedData = JSON.parse(localStorage.getItem("LoginUserData"));

      const normalisedParams = {
        ...params,
        provider_org_ids: normaliseSelection(params.provider_org_ids),
        provider_type_ids: normaliseSelection(params.provider_type_ids),
      };

      const response = await axios({
        method: "get",
        url: `${actionType.environment_url}/api/admin/GenerateLicensingGracePeriodFollowUpsReport`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
          "Content-Type": "application/json",
          organisationid: storedData?.organisation_id,
        },
        params: normalisedParams,
        paramsSerializer: (payload) =>
          qs.stringify(payload, { arrayFormat: "repeat", skipNulls: true }),
      });

      return response.data;
    } catch (error) {
      return error?.response?.data ?? { success: false, message: error.message };
    }
  };
